export const blockIconsPhotoandimageStyleNew = (
	<span className='material-symbols-outlined'>style</span>
);
